import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initTracking } from './utils/tracking';

// Loads the Reddit Pixel straight away only if consent was given on an
// earlier visit; otherwise it waits for the consent banner.
initTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

